import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

function Footer() {
    return (
        <footer data-theme="guardhartDark" className="bg-base-100 w-full pt-16 pb-8 border-t border-zinc-800">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 px-6 md:px-12 max-w-7xl mx-auto">

                <div className="flex flex-col gap-4">
                    <Link to="/" className="text-2xl font-bold tracking-tighter text-base-content hover:text-primary transition-colors">
                        Guardhart
                    </Link>
                    <p className="text-sm text-zinc-400 leading-relaxed">
                        Protecting Kenya's Future Today. Excellence in security through technical precision and human integrity.
                    </p>
                </div>

                <div className="flex flex-col gap-3">
                    <span className="text-xs font-bold uppercase tracking-widest text-primary mb-2">Navigation</span>
                    <Link to="/" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">Home</Link>
                    <Link to="/blog" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">Blog</Link>
                    <Link to="/contact" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">Contact Us</Link>
                </div>

                <div className="flex flex-col gap-3">
                    <span className="text-xs font-bold uppercase tracking-widest text-primary mb-2">Company</span>
                    <Link to="/careers" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">Careers</Link>
                    <Link to="/about" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">About</Link>
                    <Link to="/services" className="text-sm text-zinc-400 hover:text-primary transition-colors duration-200">Services</Link>
                </div>

                <div className="flex flex-col gap-3">
                    <span className="text-xs font-bold uppercase tracking-widest text-primary mb-2">Contact</span>
                    <div className="flex items-start gap-3 text-sm text-zinc-400">
                        <FiMapPin className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                        <p>Headquarters, Nairobi, Kenya<br />(Six branches nationwide)</p>
                    </div>
                    <div className="flex items-center gap-3 text-sm text-zinc-400 hover:text-primary transition-colors cursor-pointer">
                        <FiPhone className="w-4 h-4 text-primary shrink-0" />
                        <a href="tel:+254714843383">+254 117666000</a>
                    </div>
                    <div className="flex items-center gap-3 text-sm text-zinc-400 hover:text-primary transition-colors cursor-pointer">
                        <FiMail className="w-4 h-4 text-primary shrink-0" />
                        <a href="mailto:info@guardhart.co.ke">info@guardhart.co.ke</a>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-6 border-t border-zinc-800/50 flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-xs text-zinc-500">
                    © 2026 Guardhart Security Services Ltd. All rights reserved.
                </p>
                <p className="text-xs text-zinc-600">
                    PSRA Licensed | Fully Ensured
                </p>
            </div>
        </footer>
    );
}

export default Footer;